import React, { useEffect, useState } from "react";
import { Alert, AlertTitle } from "@mui/material";
import { useTranslation } from "react-i18next";

const getInitialOnlineState = () =>
  typeof navigator === "undefined" ? true : navigator.onLine;

export const OfflineStatusBanner: React.FC = () => {
  const { t } = useTranslation();
  const [isOnline, setIsOnline] = useState(getInitialOnlineState);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (isOnline) return null;

  return (
    <Alert
      severity="warning"
      variant="filled"
      square
      data-testid="offline-status-banner"
      sx={{ py: 0.5, "& .MuiAlert-message": { py: 0.25 } }}
    >
      <AlertTitle sx={{ mb: 0, fontSize: "0.875rem" }}>
        {t("offline-status-title", { defaultValue: "You are offline" })}
      </AlertTitle>
      {t("offline-status-message", {
        defaultValue: "You can continue viewing cached data. Changes will sync when the connection returns.",
      })}
    </Alert>
  );
};

export default OfflineStatusBanner;

